
<!-- Home Section -->
<section id="home" class="container-fluid home-Section">

  <div class="container content-main text-center">
    <h2 class="main-text">Mobile & Web Software Development</h2>
    <!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
    <!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>

</section>



<section id="" class="container-fluid web-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-12 text-center">
        <!--        <h2 class="pt-5 mb-3"><b>Our Portfolio</b></h2>-->
        <p>From ideation to execution, at every level we take into consideration underlying industry economics, customer needs, and competitive dynamics. We also evaluate company's existing tech maturity level for accurate gap analysis. All these form the basis of successful project discovery, development & implementation.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain">
<!--        <img class="servicesSubIcon" src="../../assets/images/IrvineTek%20-%20Software%20Development%20-%20Affordable.png">-->
        <p class="servicesSubHeading"><b>Services</b></p>
        <p class="servicesSubText">
          Discovery & Development<br>
          Deployment, QA, O&M<br>
          Digital Marketing</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain">
<!--        <img class="servicesSubIcon" src="../../assets/images/IrvineTek%20-%20Software%20Development%20-%20Reliable.png">-->
        <p class="servicesSubHeading"><b>Development</b></p>
        <p class="servicesSubText">
          Software (Web apps)<br>
          Mobile Apps<br>
          Websites</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain">
<!--        <img class="servicesSubIcon" src="../../assets/images/IrvineTek%20-%20Software%20Development%20-%20Proficient.png">-->
        <p class="servicesSubHeading"><b>Technologies</b></p>
        <p class="servicesSubText">
          UI/UX, frontend, backend<br>
          Databases, cloud, security<br>
          Analytics, AI, IoT</p>
      </div>
      <div class="col-12 col-sm-3 col-md-3 servicesSubMain">
<!--        <img class="servicesSubIcon" src="../../assets/images/IrvineTek%20-%20Software%20Development%20-%20Free%20Session.png">-->
        <p class="servicesSubHeading"><b>Consulting</b></p>
        <p class="servicesSubText">
          Project Management<br>
          Turnkey Solutions<br>
          Standardization & Upgradation</p>
      </div>
    </div>
    <div class="text-center">
      <img style="width: 60%;margin-top: 50px" src="../../assets/images/IrvineTek-IT-Services.jpg">
    </div>
  </div>
</section>

    <section id="webDevelopment" class="container-fluid web-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-6">
        <h2 class="mb-3"><b>Web Development</b></h2>
        <p><strong>Backend:</strong> Django (Python), Rials (Ruby), PHP (Laravel)</p>
        <p><strong>Frontend:</strong> Angular, React</p>
        <p><strong>Databases:</strong> Postgres, MySQL, MonoDB, Oracle</p>
        <p>Web application is actually a software but, unlike computer-based
          softwares, it runs on web servers. These solutions can be installed using
          cloud, local or hybrid server solutions. We provide all web-based
          software design and development services.
          IrvineTek develops customized web portals that are functional,
          compatible and scalable.</p>
        <p><strong>Portfolio websites</strong></p>
        <p><strong>Ecommerce websites</strong></p>
        <p><strong>CRM Applications</strong></p>
        <p><strong>Back office applications</strong></p>
        <p><strong>Enterprise solutions</strong></p>
        <p>All web based portals are developed with an option of cloud, local or
          hybrid installations. Cloud based solutions are usually flexible and
          cheaper and offer access from anywhere.</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek - Web Development.png" class="img-fluid" alt="Web Development" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Mobile App Dev Section -->
<section id="mobileAppDevelopment" class="container-fluid mobile-app-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
        <img src="assets/images/IrvineTek - Mobile Development.png" class="img-fluid" alt="Mobile App Development" style="max-height: 500px;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <h2 class="mb-3"><b>Mobile Application Development</b></h2>
        <p><strong>Native:</strong> Kotlin (Android), Swift (iOS)</p>
        <p><strong>Cross-platform:</strong> React Native, Flutter</p>
        <p><strong>PWA framework:</strong> React, Angular, Vue</p>
        <p>Getting a mobile app developed for your startup or business can be
          overwhelming. We make it simple by providing guidance at every step.</p>
        <p><strong>Native App Development</strong></p>
        <p>Native apps are developed for 1 particular operating system e.g.
          Android or iOS. The advantages of native apps include high
          performance, robust functionality and seamless user experience.</p>
        <p>It is however expensive to built because specific code cannot be used or
          shared across different platforms.</p>
        <p><strong>Cross-platform App Development</strong></p>
        <p>Cross-platform or hybrid apps are developed for multiple platforms i.e.
          majority of the code of an app is shareable across Android & iOS platforms.</p>
        <p>It is less expensive and offers similar user experience of native
          applications in most cases.</p>
        <p><strong>Progressive Web App Development</strong></p>
        <p>Progressive web application is actually a website that is designed to
          accommodate both desktop and mobile users.</p>
        <p>It does not need to be downloaded, but still offers app like experience
          to mobile users. PWAs is usually the cheapest development option.</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - Mobile Development.png" class="img-fluid" alt="Mobile App Development" style="max-height: 500px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- UI/UX Desogn Section -->
<section id="ui-ux-design" class="container-fluid ui-ux-design-section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h2 class="mb-3"><b>UI and UX Design</b></h2>
          <p><strong>Tools:</strong> Sketch, Adobe XD</p>
          <p>The key to developing any successful application is combining
            functionality with intuitive yet simple Graphical User Interfaces (GUI).</p>
          <p>A User Interface and User Experience web developer is responsible for
            designing interactive visuals for websites and web application for a
            good user experience.</p>
          <p>Work on UI and UX starts with identification of business goals, KPIs and
            industry standards. Next comes wireframing. Wireframe acts as the
            blueprint for any project and defines all key functionalities.</p>
          <p>Tools used in UI and UX design include HTML, CSS and other design
            tools to achieve responsive design.</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek - UI UX.png" class="img-fluid" alt="UI/UX Design" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Mobile App Dev Section -->
<section id="qaTesting" class="container-fluid testing-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-web">
        <img src="assets/images/IrvineTek - QA.png" class="img-fluid" alt="UI/UX Design" style="max-height: 400px;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <h2 class="mb-3"><b>Quality Assurance & Testing</b></h2>
        <p>We provide reliable quality assurance and testing services for any software
          and application related project. Comprehensive testing of any project
          includes all aspects of the application such as account setup, payment
          processing & messaging.
        </p>
        <p>Quality assurance also means testing functionality, scalability & security
          across multi-platforms such as browsers, hardware, servers etc.</p>
        <p>Unit Testing</p>
        <p>Load Testing</p>
        <p>Functional Testing</p>
        <p>Automation Testing</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center display-mobile">
        <img src="assets/images/IrvineTek - QA.png" class="img-fluid" alt="UI/UX Design" style="max-height: 400px;margin: auto">
      </div>
    </div>
  </div>
</section>
<!-- Digital Marketing Section -->
<section id="digital-marketing" class="container-fluid digital-marketing-section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h2 class="mb-3"><b>Digital Marketing</b></h2>
          <p>We offer end-to-end digital marketing services including</p>
          <p><strong>Designs, Campaigns & Content Writing</strong></p>
          <p>Same experienced designers, that create practical and aesthetically
            pleasing designs for our inhouse projects, are also available to provide
            custom designs and campaigns for your business.</p>
          <p><strong>SEO & Analytics</strong></p>
          <p>Search engine optimization is the most cost effective way to reach out
            to customers. There is no alternate to higher organic rankings. We
            employ different SEO strategies that suite your business the best. If you
            are operating locally, we focus to make your business visible locally.</p>
          <p><strong>Social Media</strong></p>
          <p>We help you build your audience and followers through social media.
            We identify your goals, perform competitive analysis and then devise
            the strategy for social media brand management.</p>
          <p><strong>Pay Per Click (PPC) Management</strong></p>
          <p>We create targeted ads, optimize bidding strategies and monitor your
            ROI for each keyword. Our optimized strategies help you reach your
            customers with precision and high ROI</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek - Digital Marketing.png" class="img-fluid" alt="Digital Marketing" style="max-height: 500px;margin: auto">
      </div>
    </div>
  </div>
</section>
